module.exports = __webpack_public_path__ + "static/media/woodgrain-lines-white.9f158f09.svg";